import React, { Component } from 'react';
import { Container, Button, Badge } from 'react-bootstrap';
import { FaMagnifyingGlass } from "react-icons/fa6";
import CheckBox from '../inc/checkbox';

const authKey = global.config.kindcode.training[6]+global.config.authBearerKey;

export default class CTSPageCompanyAdd extends Component {
  constructor (props) {
    super(props);
      this.state = {
      stPopTitle: '',
      activelink: '',
      referrer_url: '',
      company_id: '',
      company_name: '',
      company_domain: '',
      specialpage_values: [],
      specialpage_not_incompany_all: [],
      specialpage_not_incompany: [],
      keyword: '',
      error_message: '',
      formErrors: { specialpage_values: '' },
      formValid: false,
      specialpageValid: '',
    }
    this.handleSubmitExisting = this.handleSubmitExisting.bind(this);
  }
  handleInputChecked = (e) => {
    
    var setStatez = {};
    var name = e.target.id;
    var value = e.target.value;
    var stat = e.target.checked;
    var dataChecked = [];
    
    if(name === "specialpage_values") {
      dataChecked = this.state.specialpage_values;
    } 

      var resChecked = [];
      if(dataChecked.length > 0) {
        var arrChecked = dataChecked;
        arrChecked.forEach((v_data,a) => {
          a++;
            if (JSON.parse(v_data).value === JSON.parse(value).value) {
              if(stat ===  true) { resChecked.push(value); throw new Error(); }
            } else {
              resChecked.push(v_data);
              if(arrChecked.length === a) {
                if(stat ===  true) { resChecked.push(value); }
              }
            }
            
        }) 
      } else { resChecked.push(value); }
      setStatez[name] = resChecked;
      this.setState(setStatez, () => {
          this.validateField(name, resChecked)
      });
    
  }
  handlePageSearch = (e) => {
    
    var name = e.target.name;
    var value = e.target.value;
    var resultID = this.state.specialpage_not_incompany_all;
    if(value.length > 2) {
      var resultList = this.state.specialpage_not_incompany_all.sort((a, b) => a.value.localeCompare(b.value));
      var resultID = resultList.filter((list) =>  {
          return (list.value.toLowerCase().match(value.toLowerCase()) || list.name.toLowerCase().match(value.toLowerCase()));
      });
    }

    this.setState({
      [name]: value,
      specialpage_not_incompany: resultID
    });
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let specialpageValid = this.state.specialpageValid;

    switch(fieldName) {
      case 'specialpage_values': 
        specialpageValid = value.length > 0;
        fieldValidationErrors.specialpage_values = specialpageValid ? '' : 'page need to be selected';
        break;
    
      default:
        break;
    }
    
    this.setState({
      formErrors: fieldValidationErrors,
      specialpageValid: specialpageValid,
    }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.specialpageValid});
  }

  async handleSubmitExisting(e) {
    e.preventDefault();
    if((this.state.specialpage_values.length > 0)) {
      document.getElementById('loading-area').style.display = 'block';
      var datasend = {
        "company_ids": JSON.stringify({company_id: this.state.company_id, company_name: this.state.company_name, company_domain: this.state.company_domain}),
        "specialpage_values": this.state.specialpage_values,
        "form_id": "form-addspecialpage"
      };

      fetch(global.config.urlLink+"/companyspageaadd", {
        method: "POST",
        headers: {
          'Accept': "application/json",
          'Content-Type': "application/json",
          'Access-Control-Allow-Origin': "*",
          'Authorization': authKey
        },
        body: JSON.stringify(datasend),
      })
      .then((result) => {
        if (result.status === 200) {
          return result.json();
        } else {
          console.log("Something happened wrong");
        }
      })
      .then((resultJson) => {
        if(resultJson.status === '200') {
          window.location.href=this.state.referrer_url;
        }
      });        
    } else {
      var arrfieldName = ['specialpage_values'];
      var arrvalue = [this.state.specialpage_values];
      for(var ck in arrfieldName) {
        this.validateField(arrfieldName[ck], arrvalue[ck]);
      }
    }
  }

  componentDidMount() {
    document.getElementById('loading-area').style.display = 'none'; 
    var getContent = JSON.parse(document.getElementById("contentoth").innerText);

    var specialpage_incompany = getContent.specialpage_incompany;
    var sPageListCompany = [];
    var sPageListNonCompany = [];
    global.config.specialCategory.forEach((listSPage) => {
      var filterSPage = specialpage_incompany.filter((list) =>  {
        return (list.subcontent.specialPageValue === listSPage.value);
      });
      if (filterSPage.length > 0) {
        sPageListCompany.push(filterSPage[0]);
      } else {
        sPageListNonCompany.push(listSPage)
      }
    })
    this.setState({
      activelink: getContent.activelink,
      company_id: getContent.company_id,
      company_name: getContent.company_name,
      company_domain: getContent.company_domain,
      specialpage_not_incompany_all: sPageListNonCompany,
      specialpage_not_incompany: sPageListNonCompany,
      specialpage_values: [],
      referrer_url: getContent.referrer_url
    });
  }
  

  render() {
    return (
      <div className="container mb-4">
        <div>
          <div className="mt-3">
            <h5>{this.state.company_name}</h5>
            for user with domain <Badge bg="secondary">{this.state.company_domain}</Badge>
            
          </div>
          <div className="row mt-4">
            <Container>
              <form onSubmit={this.handleSubmitExisting}>
                <div className="mt-3 d-flex"> 
                  <div className="col-md-6">
                    <Button variant="dark" size="sm" type="submit">Submit</Button> 
                  </div>
                  <div className="col-md-6 d-flex justify-content-start">
                        <FaMagnifyingGlass style={{ fontSize: 25, marginTop: "5px", transform: 'scaleX(-1)' }} className="styleicons" />
                        <input type="text" className="form-control" name="keyword"
                          placeholder="search page"
                          value={this.state.keyword}
                          onChange={this.handlePageSearch}  
                        />
                        
                  </div>
                  
                </div>
                <div className=" mt-4 mb-4">
                  
                  {
                    this.state.specialpage_not_incompany.map((item2, index) => {
                      return (
                        <div style={{height:"38px"}} key={"D"+index}>
                          <CheckBox  
                            fieldId={"specialpage_values"} 
                            id={"A"+index} 
                            value={JSON.stringify(item2)}
                            isChecked={this.state.specialpage_values.includes(JSON.stringify(item2))}
                            // isDisable={false}
                            handleInputChecked={this.handleInputChecked}  label={item2.value} 
                          />
                        </div>
                      )
                    })
                  }
                  </div>
            </form>
            </Container>
          </div>
          
        </div>
        <div id="loading-area" className="d-none loading"></div> 
      </div>
    );
  }
}
